"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestShifts = exports.requestShifts2 = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("./query"));
const SHIFTS_QUERY = (options) => (0, graphql_tag_1.default) `query ShiftsQuery (
$id: ID!,
$period: PeriodFreeInput!,
$user: ID,
$users: [ID],
$locality: ID,
$useOrFilter: Boolean,
$limit: Int,
$offset: Int
) {
workspace(
  id: $id
) {
  shifts (
    period: $period
    user: $user
    users: $users
    locality: $locality
    useOrFilter: $useOrFilter
    uncommitted: ${typeof options?.includeUncommitted !== 'undefined' ? Boolean(options?.includeUncommitted).toString() : 'true'},
    limit: $limit,
    offset: $offset
  ) {
    ${query_1.default.SHIFT_PARAMS_BASIC}
    ${query_1.default.SHIFT_PARAMS_ATTENDANCE}
    ${options?.withHistory ? query_1.default.SHIFT_PARAMS_HISTORY : ''}
    ${options?.withAttendance ? query_1.default.SHIFT_PARAMS_ATTENDANCE : ''}
    ${options?.withStats ? query_1.default.SHIFT_PARAMS_STATS : ''}
  }
}
}`;
const requestShifts2 = async ({ args, options }) => {
    const COMPUTED_QUERY = SHIFTS_QUERY(options);
    const { data, errors } = await (0, apollo_1.query)(COMPUTED_QUERY, {
        variables: args,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace.shifts;
};
exports.requestShifts2 = requestShifts2;
/**
 * @description Backwards-compatability wrapper for loadShifts
 * @deprecated use requestShifts2
 */
const requestShifts = async (variables, 
// @ts-expect-error
token, options) => await (0, exports.requestShifts2)({ args: variables, options });
exports.requestShifts = requestShifts;
// async function requestShifts (variables, token, options) {
//   const response = await fetchRequest({ query: SHIFTS_QUERY, variables, token })
//   if (!response) return errUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errUtil.apiError('shifts', errors)
//   }
//   return data.workspace.shifts
// }
exports.default = exports.requestShifts;
